import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_STAFF_VIEW_ALL_SALON;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
